const CLOSED_TEXT_LABEL_ATTR = 'data-closed-text';
const OPENED_TEXT_LABEL_ATTR = 'data-opened-text';
const TOGGLE_ELEMENT_HTML = '<span class="toggle-text">###CONTENT###<span>';
const FOLDABLE_TEXT_CSS_CLASS = 'foldable-text';

const CLOSED_STATE = 0;
const OPENED_STATE = 1;

class FoldableText {
    constructor($textElement, foldInitially = false, additionalCSSClassNames = '') {
        this.state        = OPENED_STATE;
        this.$textElement = $textElement;
        this.closedText   = this.$textElement.attr(CLOSED_TEXT_LABEL_ATTR);
        this.openedText   = this.$textElement.attr(OPENED_TEXT_LABEL_ATTR);

        if (!this.textExceeds300Chars()) { return; }
        
        this.makeTextFoldable(additionalCSSClassNames);
        if (foldInitially) {
            this.foldText();
            this.insertClosedText();
        } else {
            this.insertOpenedText();
        }
    }

    makeTextFoldable(additionalCSSClassNames) {
        this.$toggleElement = $(TOGGLE_ELEMENT_HTML);
        this.$textElement.addClass(FOLDABLE_TEXT_CSS_CLASS).append(this.$toggleElement);
        this.registerClickEventOnToggleElement();
        
        if (additionalCSSClassNames) {
            this.$toggleElement.addClass(additionalCSSClassNames);
        }
    }

    foldText() {
        this.state = CLOSED_STATE;
        this.$textElement.slideUp({
            start: function() {
                $(this).addClass('text-closed-start');
            },
            done: function() {
                $(this).addClass('text-closed-completely').css('display', '');
            }
        });
        this.insertClosedText();
    }
    
    expandText() {
        this.state = OPENED_STATE;
        this.$textElement.animate({height: this.$textElement[0].scrollHeight}, {
            start: function() {
                $(this).removeClass('text-closed-completely');
            },
            done: function() {
                $(this).removeClass('text-closed-start').css('height', '');
            }
        });
        this.insertOpenedText();
    }
    
    insertOpenedText() {
        this.$toggleElement.text(this.openedText);
    }
    
    insertClosedText() {
        this.$toggleElement.text(this.closedText);
    }

    registerClickEventOnToggleElement() {
        this.$toggleElement.on('click', () => {
            if (this.state === OPENED_STATE) {
                this.foldText();
            } else {
                this.expandText();
            }
        });
    }

    textExceeds300Chars() {
        return this.$textElement[0].textContent.length > 300;
    }
}

(function($) {
    "use strict";

    $.fn.foldableText = function(foldedInitially, additionalCSSClassNames) {
        return this.each(function() {
            var $this = $(this);
            var foldedText = new FoldableText($this, foldedInitially, additionalCSSClassNames);
    
            $this.data('foldedTextPlugin', foldedText);
        });
    };
})(jQuery);